import { render } from "./AanmeldingSummary.vue?vue&type=template&id=3b689f4d"
import script from "./AanmeldingSummary.vue?vue&type=script&lang=js"
export * from "./AanmeldingSummary.vue?vue&type=script&lang=js"

import "./AanmeldingSummary.vue?vue&type=style&index=0&id=3b689f4d&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__